import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight, CalendarCheck } from 'lucide-react';
import { useLanguage } from '../i18n/LanguageContext';
export function PortfolioCTASection() {
  const {
    lang
  } = useLanguage();
  return <section className="portfolio-cta-section" style={{
    background: '#5a4579',
    padding: '60px 20px',
    borderTopLeftRadius: '32px',
    borderTopRightRadius: '32px',
    marginTop: '-24px',
    position: 'relative'
  }} data-id="element-349">
      <style data-id="element-350">{`
        @media (min-width: 769px) {
          .portfolio-cta-section { padding: 80px 40px !important; }
        }
      `}</style>
      <div className="max-w-2xl mx-auto" style={{
      textAlign: 'center'
    }} data-id="element-351">
        <motion.p initial={{
        opacity: 0,
        y: 12
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} style={{
        color: 'rgba(255,255,255,0.55)',
        fontSize: '11px',
        fontWeight: 700,
        letterSpacing: '2px',
        textTransform: 'uppercase',
        marginBottom: '12px'
      }} data-id="element-352">
          {lang === 'es' ? '¿Listo para empezar?' : 'Ready to start?'}
        </motion.p>
        <motion.h2 initial={{
        opacity: 0,
        y: 16
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        delay: 0.05
      }} className="text-[26px] md:text-[34px]" style={{
        color: '#FFFFFF',
        fontWeight: 800,
        lineHeight: 1.2,
        marginBottom: '14px'
      }} data-id="element-353">
          {lang === 'es' ? '¿Quieres una landing page ' : 'Do you want a landing page '}
          <span className="italic" style={{
          color: '#D4A5D8'
        }} data-id="element-354">
            {lang === 'es' ? 'así' : 'like this'}
          </span>{' '}
          {lang === 'es' ? 'para tu negocio?' : 'for your business?'}
        </motion.h2>
        <motion.p initial={{
        opacity: 0,
        y: 16
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        delay: 0.1
      }} style={{
        color: 'rgba(255,255,255,0.75)',
        fontSize: '15px',
        lineHeight: 1.6,
        maxWidth: '520px',
        margin: '0 auto 28px'
      }} data-id="element-355">
          {lang === 'es' ? 'Te la creamos con copy estratégico, diseño profesional y lista para vender desde el día uno.' : 'We create it for you with strategic copy, professional design, and ready to sell from day one.'}
        </motion.p>

        <motion.div initial={{
        opacity: 0,
        y: 16
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        delay: 0.15
      }} className="flex flex-col items-center" style={{
        gap: '12px',
        width: '100%',
        maxWidth: '360px',
        margin: '0 auto'
      }} data-id="element-356">
          {/* Primary button */}
          <a href="#plan-2" className="inline-flex items-center justify-center transition-all" style={{
          width: '100%',
          background: '#FFFFFF',
          color: '#1E1245',
          borderRadius: '12px',
          padding: '14px 28px',
          fontSize: '15px',
          fontWeight: 800,
          gap: '8px',
          boxShadow: '0 8px 24px rgba(0,0,0,0.25)'
        }} onMouseEnter={e => {
          const el = e.currentTarget as HTMLAnchorElement;
          el.style.transform = 'translateY(-2px)';
          el.style.boxShadow = '0 12px 32px rgba(0,0,0,0.35)';
        }} onMouseLeave={e => {
          const el = e.currentTarget as HTMLAnchorElement;
          el.style.transform = 'translateY(0)';
          el.style.boxShadow = '0 8px 24px rgba(0,0,0,0.25)';
        }} data-id="element-357">
            {lang === 'es' ? 'Quiero mi landing page' : 'I want my landing page'}
            <ArrowRight size={18} strokeWidth={2.2} data-id="element-358" />
          </a>

          {/* Secondary outlined button */}
          <a href="https://wa.me/17863037695?text=Hola%2C%20quiero%20una%20sesi%C3%B3n%20estrat%C3%A9gica%20gratuita%20con%20Inkova." target="_blank" rel="noopener noreferrer" className="inline-flex items-center justify-center transition-all" style={{
          width: '100%',
          background: 'transparent',
          color: '#FFFFFF',
          border: '1px solid #FFFFFF',
          borderRadius: '12px',
          padding: '14px 28px',
          fontSize: '15px',
          fontWeight: 700,
          gap: '8px'
        }} onMouseEnter={e => {
          const el = e.currentTarget as HTMLAnchorElement;
          el.style.background = '#FFFFFF';
          el.style.color = '#1E1245';
        }} onMouseLeave={e => {
          const el = e.currentTarget as HTMLAnchorElement;
          el.style.background = 'transparent';
          el.style.color = '#FFFFFF';
        }} data-id="element-359">
            <CalendarCheck size={18} strokeWidth={2.2} data-id="element-360" />
            {lang === 'es' ? 'Quiero mi sesión' : 'I want my session'}
          </a>

          {/* Reassurance microcopy */}
          <p style={{
          fontSize: '12px',
          color: '#C4B5FD',
          textAlign: 'center',
          marginTop: '4px'
        }} data-id="element-361">
            {lang === 'es' ? 'Sin compromiso · 30 minutos · 100% gratuita' : 'No commitment · 30 minutes · 100% free'}
          </p>
        </motion.div>
      </div>
    </section>;
}